import { MY_TEAM_LABELS } from 'constants/myTeam';
import { WORK_STATUS } from 'constants/dashboard';
import { DATE_DISPLAY_FORMAT } from 'constants/appConstants';
import { WORKLOG_OFFICE_PRESENT } from 'constants/attendanceActionStatus';
import { WORK_LOCATION_SHORT, WORK_SHIFT_LABELS } from 'constants/worklog';

import type { TeamRosterDay } from '../types';
import { getRosterWeekDay } from '../utils/roster';

import { getFormattedDate, isDateInFuture, isDateToday } from 'utils/date';

interface RosterInfoPopupProps {
  day: TeamRosterDay;
  index: number;
  rosterExpiry?: string | null;
}

const RosterInfoPopup = ({ day, index, rosterExpiry }: RosterInfoPopupProps) => {
  const weekDay = getRosterWeekDay(day?.workDate, index);

  let locationText = MY_TEAM_LABELS.PLACEHOLDER;
  if (day?.location === WORK_LOCATION_SHORT.OFFICE) {
    locationText = WORKLOG_OFFICE_PRESENT;
  } else if (day?.location === WORK_LOCATION_SHORT.HOME) {
    locationText = WORK_STATUS.WFH;
  }

  const shiftLabel = WORK_SHIFT_LABELS[day?.workShift] || day?.workShift || MY_TEAM_LABELS.PLACEHOLDER;
  const rosterUntilText =
    isDateToday(rosterExpiry) || isDateInFuture(rosterExpiry)
      ? getFormattedDate(rosterExpiry, DATE_DISPLAY_FORMAT)
      : MY_TEAM_LABELS.PLACEHOLDER;

  const rosterInfoHeader = day?.location
    ? `${weekDay} • ${day.location === WORK_LOCATION_SHORT.HOME ? WORK_STATUS.WFH : day.location}`
    : `${weekDay}`;

  return (
    <div className="my-team__roster-content">
      <h2 className="my-team__roster-title">{rosterInfoHeader}</h2>
      <div className="my-team__roster-body">
        <p className="my-team__roster-info-row">
          <span>{MY_TEAM_LABELS.SHIFT}</span>
          <span className="my-team__roster-value">{shiftLabel}</span>
        </p>
        <p className="my-team__roster-info-row">
          <span>{MY_TEAM_LABELS.ROSTER}</span>
          <span className="my-team__roster-value">{locationText}</span>
        </p>
        <p className="my-team__roster-info-row">
          <span>{MY_TEAM_LABELS.ROSTER_UNTIL}</span>
          <span className="my-team__roster-value">{rosterUntilText}</span>
        </p>
      </div>
    </div>
  );
};

export default RosterInfoPopup;
